import { amIImpersonating, GenericWrapperContext, LoadingContainer, TemplateModel } from "@cakemail-org/ui-components-v2"
import { IframeHTMLAttributes, useContext, useEffect, useRef, useState } from "react"
import "./styles.scss"
import { TemplateDetailContainerContext } from "../../../container/templates/context"
import { updateIframe } from "../../../utils/components"
import { ResourcePreview } from "../../Resources/preview"


export function TemplatePreview({ }: {}) {
    const genericWrapper = useContext(GenericWrapperContext)
    const templateDetailContext = useContext(TemplateDetailContainerContext)
    const [preview, setPreview] = useState<string | null | undefined>()
    const frameRef = useRef<HTMLIFrameElement | null>(null)

    useEffect(fetchPreview, [])
    useEffect(() => {
        const iframe = frameRef.current as HTMLIFrameElement
        updateIframe(iframe, preview)
    }, [preview])

    const template = templateDetailContext.template

    function fetchPreview() {
        template.render({ brandAccountId: amIImpersonating(true) || genericWrapper.account?.id }).then((data) => {
            setPreview(data)
        }).catch(() => {
            setPreview(null)
        })
    }

    return <ResourcePreview content={preview} />
}